import Glider from "glider-js";

(function () {
  const menus = document.querySelectorAll("[data-js-topplist-menu]");

  for (const menu of menus) {
    new Glider(menu, {
      slidesToShow: "auto",
      slidesToScroll: "auto",
      itemWidth: "auto",
      resizeLock: false,
      draggable: true,
      skipTrack: true,
    });
  }
})();
